<div class="card" *ngIf="candidates?.length && !isLoading">
  <div class="card-header">
    <div class="row align-items-center">
      <div class="col">
        <div class="input-group input-group-flush input-group-merge">
          <input type="search" name="q" [(ngModel)]="q" (ngModelChange)="searchSoon()" class="form-control search"
            [placeholder]="'Suchen'">
          <div class="input-group-prepend ">
            <div class="input-group-text">
              <i class="fa-sharp fa-solid fa-magnifying-glass"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="card-body card-body-list">

    <div class="row" [scAnchorTarget]="'Kandidat:innen'">

      <div class="col-12">

        <div class="list-group">
          <a class="list-group-item list-group-item-action" routerLink="/candidates/{{ a.Id }}"
            *ngFor="let a of candidates">

            <div class="row align-items-center">

              <div class="col-auto">
                <sc-avatar class="circle-danger" [user]="a" size="sm"></sc-avatar>
              </div>

              <div class="col col-shrink ms-n2 candidate-desc">
                <div class="fw-bold d-inline-block candidate-name mb-0">{{ a.FirstName }} {{ a.LastName }}</div>
                <p class="small text-muted job-title mb-0 fw-normal oneline" *ngIf="a.JobTitle">{{ a.JobTitle }}</p>
              </div>

              <div class="col-auto">
                <a *ngIf="a.XingUri" [stopClickPropagation] class="btn btn-sm btn-dark btn-circle me-2"
                  href="{{a.XingUri}}" target="_blank">
                  <fa class="fa-brands fa-xing"></fa>
                </a>
                <a *ngIf="!a.XingUri" [stopClickPropagation] [preventDefault]
                  class="btn btn-sm btn-dark btn-circle me-2" style="opacity: .5;">
                  <fa class="fa-brands fa-xing"></fa>
                </a>
                <a *ngIf="a.LinkedInUri" [stopClickPropagation] class="btn btn-sm btn-dark btn-circle me-2"
                  href="{{a.LinkedInUri}}" target="_blank">
                  <fa class="fa-brands fa-linkedin-in"></fa>
                </a>
                <a *ngIf="!a.LinkedInUri" [stopClickPropagation] [preventDefault]
                  class="btn btn-sm btn-dark btn-circle me-2" style="opacity: .5;">
                  <fa class="fa-brands fa-linkedin-in"></fa>
                </a>
              </div>

            </div>
          </a>
        </div>

      </div>
    </div>

  </div>
</div>